var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { height: "100%" } }, [
    !_vm.hidden
      ? _c(
          "div",
          { staticClass: "breadcrumb-layout" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页")
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("公司人员管理")])
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "column-layout clearfix",
        staticStyle: { height: "100%", overflow: "hidden" }
      },
      [
        _c(
          "div",
          {
            staticClass: "left-column fl",
            class: { active: !_vm.treeCollapse }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: { "overflow-y": "auto" },
                attrs: { id: "tree-menu" }
              },
              [
                _c("swb-org-tree", {
                  attrs: {
                    searchSize: "mini",
                    bizUnitIds: _vm.bizUnitIds,
                    bizUnitId: _vm.bizUnitId,
                    isCurrentCom: _vm.isCurrentCom,
                    showIncludeSubComs: true,
                    isCom: _vm.isCom,
                    bizDepart: true,
                    isSelectThisLevel: _vm.isSelectThisLevel,
                    enableSearch: true
                  },
                  on: {
                    "notity-change": function($event) {
                      _vm.notityChange($event)
                    },
                    "show-tree-collapse": function($event) {
                      _vm.showTreeCollapse($event)
                    }
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right-column fl" }, [
          _c("div", [
            _c("div", { staticClass: "tab-container base" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "tabs-content" }, [
                _c(
                  "ul",
                  { staticClass: "body", staticStyle: { padding: "0" } },
                  [
                    _c(
                      "li",
                      { staticClass: "body-item" },
                      [
                        _c("swb-com-staff-select", {
                          ref: "swb_com_staff_select",
                          attrs: {
                            comId: _vm.comId,
                            bizUnitFlag: false,
                            checkBox: _vm.checkBox,
                            selectedIds: _vm.selectedIds,
                            roleIds: _vm.roleIds
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tab-container base" }, [
      _c("div", { staticClass: "tabs-nav" }, [
        _c("ul", { staticClass: "head" }, [
          _c("li", { staticClass: "head-item current" }, [_vm._v("组织机构")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabs-nav" }, [
      _c("ul", { staticClass: "head clearfix" }, [
        _c("li", { staticClass: "head-item current" }, [
          _c("a", { staticClass: "font14" }, [_vm._v("员工信息")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bf69df9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bf69df9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/orgStruct/ComStaffMainSelect.vue
// module id = 2242
// module chunks = 0